export default __webpack_public_path__ + "static/media/green_bottle.be0e8ddb.svg";